
import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: 'UI_Loader',
  props: {
    type: {
      validator (value: string) {
        return ['inline', 'overlay', 'fullscreen'].includes(value)
      }
    },
    color: { type: String, default: '#ffffff' },
    backgroundcolor: { type: String, default: '#33333350' },
    spin: { type: Boolean, default: true }
  },
  computed: {
    metadata () {
      return this.$store.getters['uiStateModule/getGlobalLoaderScreenState']
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "aeef137a": (_ctx.backgroundcolor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__